module.exports = __webpack_public_path__ + "static/media/event-image.12081808.png";